import React from 'react';
import './ErrorMain.scss';

class ErrorMain extends React.Component{
  render(){
    return(
      <div className="page-not-found"> 404 Not Found </div>
    );
  }
}

export default ErrorMain;
